import baseRequest from "_core/baseRequest";

export default {
    getEmbedToken: ({dashboardKey}) =>
        baseRequest.get(`/metabase-reports/${dashboardKey}/embed-token`)
};
